import { styled } from 'styled-system/jsx';
import { button, type ButtonVariantProps } from 'styled-system/recipes';
import type { ComponentProps } from 'styled-system/types';

import { ark } from '@ark-ui/react/factory';

export type IconButtonProps = ComponentProps<typeof IconButton>;
export const IconButton = styled(ark.button, button, {
  defaultProps: { px: '0' } as ButtonVariantProps,
});
